<field var="{{{o.name}}}">
{[ if (o.value.constructor === Array) { ]}
    {[ o.value.forEach(function (arrayValue) { ]}<value>{{{arrayValue}}}</value>{[ }); ]}
{[ } else { ]}
    <value>{{{o.value}}}</value>
{[ } ]}</field>
